import React from "react";
import Lottie from "lottie-react";
import arrowIcon from "../assets/images/Vector_btn.png";
import bkgAzzurro from "../assets/images/bkg-azzurro.svg";
import TimelineLottie from "../assets/json/sezione-03-2-img-01.json";

// Events in chronological order; "pos" = above/below the line (desktop)
const EVENTI = [
  { data: "", titolo: "Progressive extension of the Gender Equality Certification", pos: "below" },
  { data: "05.02", titolo: "Mutuality Prize", pos: "above" },
  { data: "21.02", titolo: "Financial solidity rating", pos: "below" },
  { data: "17.04", titolo: "Banco Desio – Italiana Assicurazioni Partnership", pos: "above" },
  { data: "09.05", titolo: "25 years of Banca Reale", pos: "below" },
  { data: "17.06", titolo: "Transfer of Reale Mutua’s stake in Ydrogios to Reale International", pos: "above" },
  { data: "29.10", titolo: "Banca Popolare Alto Adige – Italiana Assicurazioni Partnership", pos: "below" },
  { data: "01.12", titolo: "Finint Private Bank – Italiana Assicurazioni Agreement", pos: "above" },
  { data: "01.12", titolo: "Great Place to Work® Certification for Reale Group", pos: "below" },
  { data: "31.12", titolo: "Net Promoter Score recognition", pos: "above" },
];

const NAVY = "#002655";
const RING = "#3a52a0";

// Ring-shaped dot
const Dot = () => (
  <div
    className="w-7 h-7 rounded-full bg-white border-[4px] flex-shrink-0"
    style={{ borderColor: RING, boxShadow: `0 0 0 2px ${NAVY}` }}
  />
);

export default function SezioneEventi() {
  return (
    <section
      id="sezione-eventi"
      className="w-full py-12 md:py-16 bg-[#dceef9]"
      style={{ backgroundImage: `url(${bkgAzzurro})`, backgroundSize: "cover", backgroundPosition: "center", backgroundRepeat: "no-repeat" }}
    >
      <div className="mx-auto xl:w-[1440px] px-5 xl:px-0">
        <h2 className="text-center mb-8 md:mb-10" style={{ color: NAVY }}>
          Main events during the financial year
        </h2>

        {/* ---------- DESKTOP: alternating horizontal timeline ---------- */}
        <div className="hidden md:block relative">
          {/* Lottie illustration + "2025" (absolute, overflows to the left) */}
          <div className="absolute left-0 -bottom-[130px] w-[22%] pointer-events-none select-none">
            <Lottie animationData={TimelineLottie} loop autoplay style={{ width: "100%", height: "auto" }} />
            <span className="absolute top-[2%] left-[65%] font-bold text-[#002655] text-[28px] xl:text-[40px] leading-none">
              2025
            </span>
          </div>

          {/* Events (horizontal scroll on tablet to avoid the break) */}
          <div className="overflow-x-auto overscroll-x-contain">
            <div className="flex pl-[20%] min-w-[1280px]">
            {EVENTI.map((e, i) => (
              <div key={i} className="flex-1 flex flex-col items-center">
                {/* slot ABOVE */}
                <div className="h-[240px] w-full flex flex-col justify-end items-start text-left px-1">
                  {e.pos === "above" && (
                    <>
                      <div className="text-[16px] xl:text-[18px] leading-tight font-bold" style={{ color: NAVY }}>
                        {e.titolo}
                      </div>
                      <div className="text-[22px] xl:text-[26px] font-bold mt-3" style={{ color: NAVY }}>
                        {e.data}
                      </div>
                      <div className="w-[2px] h-6 mt-2 ml-[9px]" style={{ background: NAVY }} />
                    </>
                  )}
                </div>

                {/* dot on the line */}
                <div className="relative w-full flex justify-start">
                  <div className="absolute top-1/2 -translate-y-1/2 left-0 right-0 h-[2px]" style={{ background: NAVY }} />
                  <div className="relative">
                    <Dot />
                  </div>
                </div>

                {/* slot BELOW */}
                <div className="h-[230px] w-full flex flex-col justify-start items-start text-left px-1">
                  {e.pos === "below" && (
                    <>
                      <div className="w-[2px] h-6 mb-2 ml-[9px]" style={{ background: NAVY }} />
                      {e.data && (
                        <div className="text-[22px] xl:text-[26px] font-bold" style={{ color: NAVY }}>
                          {e.data}
                        </div>
                      )}
                      <div className="text-[16px] xl:text-[18px] leading-tight font-bold mt-2" style={{ color: NAVY }}>
                        {e.titolo}
                      </div>
                    </>
                  )}
                </div>
              </div>
            ))}
            </div>
          </div>
        </div>

        {/* ---------- MOBILE: vertical timeline (without illustration) ---------- */}
        <div className="md:hidden flex flex-col">
          <div className="w-full flex flex-col">
            {EVENTI.map((e, i) => (
              <div key={i} className="flex gap-4">
                {/* vertical line + dot */}
                <div className="flex flex-col items-center">
                  <Dot />
                  {i < EVENTI.length - 1 && (
                    <div className="w-[2px] flex-1 my-1" style={{ background: NAVY }} />
                  )}
                </div>
                {/* content */}
                <div className="pb-8">
                  {e.data && (
                    <div className="text-[26px] font-bold leading-none" style={{ color: NAVY }}>
                      {e.data}
                    </div>
                  )}
                  <div className="text-[18px] font-bold leading-snug mt-1" style={{ color: NAVY }}>
                    {e.titolo}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Consult the Report button */}
        <div className="flex justify-center mt-8 md:mt-6">
          <a href="https://www.realegroup.eu/groupshare/0/EN/ListaReportsAndAccounts/64/Reale%20Group_Integrated%20Consolidated%20Financial%20Statement%202025.pdf#page=19" target="_blank">
          <button type="button" className="bt-secondary flex items-center gap-2">
            <img src={arrowIcon} alt="" className="w-[22px] h-[22px]" />
            Consult the Report - chapter 1 par.1.1.3.2
          </button>
          </a>
        </div>
      </div>
    </section>
  );
}
